export default "__VITE_ASSET__DpAuAQYc__"